import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import _ from 'lodash'
import { getCurrentLanguage } from 'utils/language'
import styled from 'styled-components'

const StoreList = styled.div`
  display: flex;
  flex-direction: ${props => props.direction};
  .store-item {
    margin-right: 16px;
    display: inline-flex;
    margin-bottom: ${props => props.direction === 'column' ? 8 : 0}px;
    &:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
    img {
      height: 48px;
    }
  }
`

const DownloadMobileApp = ({ className, direction = 'row' }) => {
  return (
    <StaticQuery
      query={graphql`
        {
          vi: markdownRemark(fields: { slug: { eq: "/vi/site-config/" } }) {
            frontmatter {
              footer {
                mobileApp {
                  label
                  appStore {
                    link
                    icon {
                      publicURL
                    }
                  }
                  googlePlay {
                    link
                    icon {
                      publicURL
                    }
                  }
                }
              }
            }
          }
          en: markdownRemark(fields: { slug: { eq: "/en/site-config/" } }) {
            frontmatter {
              footer {
                mobileApp {
                  label
                  appStore {
                    link
                    icon {
                      publicURL
                    }
                  }
                  googlePlay {
                    link
                    icon {
                      publicURL
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const currentLanguage = getCurrentLanguage()
        if (!_.has(data, currentLanguage)) return null
        const { mobileApp } = data[currentLanguage].frontmatter.footer
        return (
          <StoreList className={className} direction={direction}>
            <a href='http://bit.ly/tungtung-ios' className='store-item'>
              <img src={mobileApp.appStore.icon.publicURL} alt='ios' />
            </a>
            <a href='http://bit.ly/tungtung-android' className='store-item'>
              <img src={mobileApp.googlePlay.icon.publicURL} alt='android' />
            </a>
          </StoreList>
        )
      }}
    />
  )
}

export default DownloadMobileApp
